'use client';
import { ShareCartIcon } from '@avtopro/icons';
import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import { useTranslations } from 'next-intl';
import useAnalytics from '@/utils/analytics';

interface ShareButtonProps
	extends DetailedHTMLProps<
		ButtonHTMLAttributes<HTMLButtonElement>,
		HTMLButtonElement
	> {
	analyticsData?: Record<string, string | boolean>;
	referrer: string;
}

const ShareButton = ({
	className,
	analyticsData,
	referrer,
	...props
}: ShareButtonProps) => {
	const t = useTranslations('PartPage');
	const analytics = useAnalytics({
		common: analyticsData,
		pushPageView: true,
		referrer: referrer,
	});
	return (
		<button
			className={`btn btn-transparent text-blue-deep flex h-fit items-center gap-2 ${className}`}
			{...props}
			onClick={() => {
				analytics?.pushEvent('page:clickToShare');
				navigator.share({
					title: document.title,
					url: window.location.href,
				});
			}}
			value={t('shareLink')}
			aria-label={t('shareLink')}>
			<span className="text-blue-deep! hidden sm:inline-block">
				{useTranslations('PartPage')('share')}
			</span>
			<ShareCartIcon className="text-blue-deep h-4 w-4" />
		</button>
	);
};

export default ShareButton;
